<script lang="ts">
  import { Filters } from "../../../../utils/Constant/Constant";
  import FeatherIcon from "svelte-feather-icon";

</script>
<div class="d-none-productlist filter-toggle">
    <h6 class="mb-0">{Filters}
        <span class="ms-2">
            <FeatherIcon class="toggle-data" icon="chevron-down" />
        </span>
    </h6>
</div>